import { useState } from 'react';
import {
  ClearSelectionButton,
  SelectHeader,
  SelectLabelText,
  SelectWithoutVisibleLabel,
  SelectWrapper,
} from './lmi-document-type-select.style';

interface LmiDocumentTypeSelectProps {
  onChange: (value: string, e?: unknown) => void;
  value: number | string;
  disabled: boolean;
  options: {
    disabled?: boolean;
    selected?: boolean;
    text: string;
    value?: number | string;
  }[];
}

export const LmiDocumentTypeSelect = ({
  onChange,
  value,
  options,
  disabled,
}: LmiDocumentTypeSelectProps) => {
  const [error, setError] = useState<string>('');
  const hasSelection = value !== '' && value !== undefined && value !== null;
  const canClear = hasSelection && !disabled;

  const validateSelectChange = (nextValue: string) => {
    if (!nextValue) {
      setError('Please select a document type');
    } else {
      setError('');
    }
  };

  const handleClear = () => {
    if (!canClear) return;
    onChange('');
    setError('');
  };

  return (
    <SelectWrapper>
      <SelectHeader>
        <SelectLabelText>Document type*</SelectLabelText>
        <ClearSelectionButton
          type="button"
          disabled={!canClear}
          onClick={handleClear}
          data-testid="clear-document-type-selection"
        >
          Clear selection
        </ClearSelectionButton>
      </SelectHeader>
      <SelectWithoutVisibleLabel
        disabled={disabled}
        id="lmi-document-type-select"
        label="Document type"
        withEmptyPlaceholder
        loading={false}
        required
        minHeight="auto"
        name="lmiDocumentType"
        onChange={(nextValue, e) => {
          onChange(nextValue, e);
          validateSelectChange(nextValue);
        }}
        options={options}
        value={value}
        errorText={error}
      />
    </SelectWrapper>
  );
};
